import axios from 'axios';
import _ from 'lodash';
import { COOKIE_DEFAULT_EXPIRY_TIME } from '../../../constants/defaults';
const { API } = require('../../../config/' + process.env.REACT_APP_ENV);
const { createProspectContact } = require('../Coupon/CouponService');

const mainAxios = axios.create({
  baseURL: API.SERVER,
  withCredentials: true
});

const errorHandler = err => {
  console.log(err);
};

export const generateSession = async isLoggedIn => {
  let { ProspectId } = await createProspectContact(isLoggedIn);

  // Await until the singleton Prospect Id is returned.
  if (!ProspectId) {
    await _.delayExecution(1000);
    let newData = await createProspectContact(isLoggedIn);
    ProspectId = newData.ProspectId;
  }

  const sessionResponse = await mainAxios.post(
    `/api/userwebsession/generate-session?prospectId=${ProspectId}`
  );

  if (
    sessionResponse.data &&
    !sessionResponse.data.ErrorOccurred &&
    !_.isEmpty(sessionResponse.data.Result)
  ) {
    const { SessionGUID } = sessionResponse.data.Result;
    await _.setCookie('session-guid', SessionGUID, COOKIE_DEFAULT_EXPIRY_TIME);
    return SessionGUID;
  }

  errorHandler('Something went wrong generating userWebSession.');
};

export const destroySession = async (prospectId, sessionGUID) => {
  mainAxios.post(
    `/api/userwebsession/deactivate-session?prospectId=${prospectId}&sessionGUID=${sessionGUID}'    `
  );

  _.eraseCookie('session-guid');
};
